import { FieldTypes } from '../constants/FieldTypes'
import { Field } from '../types/forms'

export const abilityIdField: Field = {
  type: FieldTypes.TEXT,
  optional: true,
  placeholder: 'Payer ID - required for claim submission',
}
